import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Input,
  NumberInput,
  NumberInputField,
  Center,
  Text,
  VStack,
  Stack,
  Radio,
  RadioGroup,
  Button,
  Alert,
  AlertIcon,
  AlertTitle,
  HStack,
  Checkbox,
  useToast,
  Textarea,
} from '@chakra-ui/react';
import { useState, useEffect, React } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  updateShinglesField,
  updateWarrantyField,
  updateWarrantyFieldTwo,
  updateHasBeenSaved,
} from '../../features/price/priceSlice';
import axios from 'axios';
import useUser from '../../hooks/useUser';
import mixpanel from 'mixpanel-browser';

const ShinglesPrices = ({ checkShinglePriceCompletion }) => {
  const dispatch = useDispatch();
  const shingles = useSelector(state => state.price.shingles);
  const warranty = useSelector(state => state.price.warranty);
  const warrantyTwo = useSelector(state => state.price.warrantyTwo);
  const savedList = useSelector(state => state.price.hasBeenSaved);
  const oneYearDescription = useSelector(
    state => state.payment.options.oneYearDescription
  );
  const threeYearDescription = useSelector(
    state => state.payment.options.threeYearDescription
  );
  const sevenYearDescription = useSelector(
    state => state.payment.options.sevenYearDescription
  );
  const toast = useToast();
  const [unsavedChanges, setUnsavedChanges] = useState(false);
  const { user } = useUser();
  const [estimateDescription, setEstimateDescription] = useState(
    shingles.estimateDescription ?? ''
  );
  const [estimateDescriptionBetter, setEstimateDescriptionBetter] = useState(
    shingles.estimateDescriptionBetter ?? ''
  );
  const [estimateDescriptionBest, setEstimateDescriptionBest] = useState(
    shingles.estimateDescriptionBest ?? ''
  );
  const [manufacturer, setManufacturer] = useState(shingles.manufacturer ?? '');
  const [shingleType, setShingleType] = useState(shingles.shingleType ?? '');
  const [line, setLine] = useState(shingles.line ?? '');
  const [color, setColor] = useState(shingles.color ?? '');
  const [unit, setUnit] = useState(shingles.unit ?? '');
  const [pricePer, setPricePer] = useState(shingles.pricePer ?? '');
  const [extraLaborPerSq, setExtraLaborPerSq] = useState(
    shingles.extraLaborPerSq ?? ''
  );
  const [hasPaymentOptionOne, setHasPaymentOptionOne] = useState(
    shingles.hasPaymentOptionOne ?? false
  );
  const [hasPaymentOptionThree, setHasPaymentOptionThree] = useState(
    shingles.hasPaymentOptionThree ?? false
  );
  const [hasPaymentOptionSeven, setHasPaymentOptionSeven] = useState(
    shingles.hasPaymentOptionSeven ?? false
  );
  const [hasPaymentOptionOneBetter, setHasPaymentOptionOneBetter] = useState(
    shingles.hasPaymentOptionOneBetter ?? false
  );
  const [hasPaymentOptionThreeBetter, setHasPaymentOptionThreeBetter] =
    useState(shingles.hasPaymentOptionThreeBetter ?? false);
  const [hasPaymentOptionSevenBetter, setHasPaymentOptionSevenBetter] =
    useState(shingles.hasPaymentOptionSevenBetter ?? false);
  const [hasPaymentOptionOneBest, setHasPaymentOptionOneBest] = useState(
    shingles.hasPaymentOptionOneBest ?? false
  );
  const [hasPaymentOptionThreeBest, setHasPaymentOptionThreeBest] = useState(
    shingles.hasPaymentOptionThreeBest ?? false
  );
  const [hasPaymentOptionSevenBest, setHasPaymentOptionSevenBest] = useState(
    shingles.hasPaymentOptionSevenBest ?? false
  );
  useState(shingles.hasPaymentOptionSevenBetter ?? false);

  const [manufacturerBetter, setManufacturerBetter] = useState(
    shingles.manufacturerBetter ?? ''
  );
  const [shingleTypeBetter, setShingleTypeBetter] = useState(
    shingles.shingleTypeBetter ?? ''
  );
  const [lineBetter, setLineBetter] = useState(shingles.lineBetter ?? '');
  const [colorBetter, setColorBetter] = useState(shingles.colorBetter ?? '');
  const [unitBetter, setUnitBetter] = useState(shingles.unitBetter ?? '');
  const [pricePerBetter, setPricePerBetter] = useState(
    shingles.pricePerBetter ?? ''
  );
  const [extraLaborPerSqBetter, setExtraLaborPerSqBetter] = useState(
    shingles.extraLaborPerSqBetter ?? ''
  );

  const [manufacturerBest, setManufacturerBest] = useState(
    shingles.manufacturerBest ?? ''
  );
  const [shingleTypeBest, setShingleTypeBest] = useState(
    shingles.shingleTypeBest ?? ''
  );
  const [lineBest, setLineBest] = useState(shingles.lineBest ?? '');
  const [colorBest, setColorBest] = useState(shingles.colorBest ?? '');
  const [unitBest, setUnitBest] = useState(shingles.unitBest ?? '');
  const [pricePerBest, setPricePerBest] = useState(shingles.pricePerBest ?? '');
  const [extraLaborPerSqBest, setExtraLaborPerSqBest] = useState(
    shingles.extraLaborPerSqBest ?? ''
  );

  const [warrantyName, setWarrantyName] = useState(warranty.name ?? '');
  const [warrantyPrice, setWarrantyPrice] = useState(warranty.price ?? '');
  const [isPerJob, setIsPerJob] = useState(warranty.isPerJob ?? false);
  const [isPerSq, setIsPerSq] = useState(warranty.isPerSq ?? false);

  const [warrantyNameTwo, setWarrantyNameTwo] = useState(
    warrantyTwo.name ?? ''
  );
  const [warrantyPriceTwo, setWarrantyPriceTwo] = useState(
    warrantyTwo.price ?? ''
  );
  const [isPerJobTwo, setIsPerJobTwo] = useState(warrantyTwo.isPerJob ?? false);
  const [isPerSqTwo, setIsPerSqTwo] = useState(warrantyTwo.isPerSq ?? false);

  const handleSave = async () => {
    try {
      // if (process.env.REACT_APP_ENVIRONMENT === 'prod') {
      //   mixpanel.track('User saved the Shingles Material prices.');
      // }
      dispatch(
        updateShinglesField({
          newValue: manufacturer,
          fieldToUpdate: 'manufacturer',
        })
      );
      const token = await user.getIdToken();
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/prices/shingles`,
        {
          username: user.email,
          shingles: {
            manufacturer: manufacturer,
            shingleType: shingleType,
            line: line,
            unit: unit,
            pricePer: pricePer,
            color: color,
            extraLaborPerSq: extraLaborPerSq,
            estimateDescription: estimateDescription,
            manufacturerBetter: manufacturerBetter,
            shingleTypeBetter: shingleTypeBetter,
            lineBetter: lineBetter,
            unitBetter: unitBetter,
            pricePerBetter: pricePerBetter,
            colorBetter: colorBetter,
            extraLaborPerSqBetter: extraLaborPerSqBetter,
            estimateDescriptionBetter: estimateDescriptionBetter,
            manufacturerBest: manufacturerBest,
            shingleTypeBest: shingleTypeBest,
            lineBest: lineBest,
            unitBest: unitBest,
            pricePerBest: pricePerBest,
            colorBest: colorBest,
            extraLaborPerSqBest: extraLaborPerSqBest,
            estimateDescriptionBest: estimateDescriptionBest,
            hasPaymentOptionOne: hasPaymentOptionOne,
            hasPaymentOptionThree: hasPaymentOptionThree,
            hasPaymentOptionSeven: hasPaymentOptionSeven,
            hasPaymentOptionOneBetter: hasPaymentOptionOneBetter,
            hasPaymentOptionThreeBetter: hasPaymentOptionThreeBetter,
            hasPaymentOptionSevenBetter: hasPaymentOptionSevenBetter,
            hasPaymentOptionOneBest: hasPaymentOptionOneBest,
            hasPaymentOptionThreeBest: hasPaymentOptionThreeBest,
            hasPaymentOptionSevenBest: hasPaymentOptionSevenBest,
          },
          warranty: {
            isPerJob: isPerJob,
            isPerSq: isPerSq,
            price: warrantyPrice,
            name: warrantyName,
          },
          warrantyTwo: {
            isPerJob: isPerJobTwo,
            isPerSq: isPerSqTwo,
            price: warrantyPriceTwo,
            name: warrantyNameTwo,
          },
        },
        {
          headers: {
            authorization: `${token}`,
          },
        }
      );

      dispatch(updateHasBeenSaved('shingles'));
      checkShinglePriceCompletion(
        {
          manufacturer: manufacturer,
          shingleType: shingleType,
          line: line,
          unit: unit,
          pricePer: pricePer,
          color: color,
          extraLaborPerSq: extraLaborPerSq,
          estimateDescription: estimateDescription,
          manufacturerBetter: manufacturerBetter,
          shingleTypeBetter: shingleTypeBetter,
          lineBetter: lineBetter,
          unitBetter: unitBetter,
          pricePerBetter: pricePerBetter,
          colorBetter: colorBetter,
          extraLaborPerSqBetter: extraLaborPerSqBetter,
          estimateDescriptionBetter: estimateDescriptionBetter,
          manufacturerBest: manufacturerBest,
          shingleTypeBest: shingleTypeBest,
          lineBest: lineBest,
          unitBest: unitBest,
          pricePerBest: pricePerBest,
          colorBest: colorBest,
          extraLaborPerSqBest: extraLaborPerSqBest,
          estimateDescriptionBest: estimateDescriptionBest,
        },
        {
          isPerJob: isPerJob,
          isPerSq: isPerSq,
          price: warrantyPrice,
          name: warrantyName,
        },
        {
          isPerJob: isPerJobTwo,
          isPerSq: isPerSqTwo,
          price: warrantyPriceTwo,
          name: warrantyNameTwo,
        },
        [...savedList, 'shingles']
      );
      setUnsavedChanges(false);
    } catch (error) {
      console.log('error: ' + error);
    }

    toast({
      title: 'Changes saved',
      description: 'Your pricing was updated.',
      status: 'success',
      duration: 2000,
      isClosable: true,
    });
  };

  return (
    <Box>
      <VStack spacing="50px">
        <Table size="sm">
          <Thead>
            <Tr>
              <Th></Th>
              <Th fontSize="xs">Manufacturer</Th>
              <Th fontSize="xs">Type</Th>
              <Th fontSize="xs">Line</Th>
              <Th fontSize="xs">Color</Th>
              <Th fontSize="xs">Sqs per Bundle</Th>
              <Th fontSize="xs">$ per Bundle</Th>
              <Th fontSize="xs">Extra Labor per Sq.</Th>
              <Th fontSize="xs">Payment Options</Th>
              <Th fontSize="xs">Estimate Description</Th>
            </Tr>
          </Thead>
          <Tbody>
            <Tr>
              <Td>Good</Td>
              <Td>
                <Input
                  maxWidth="150px"
                  value={manufacturer}
                  onChange={event => {
                    setUnsavedChanges(true);
                    setManufacturer(event.target.value);
                  }}
                />
              </Td>
              <Td>
                <Input
                  maxWidth="150px"
                  value={shingleType}
                  onChange={event => {
                    setUnsavedChanges(true);
                    setShingleType(event.target.value);
                  }}
                />
              </Td>
              <Td>
                <Input
                  maxWidth="200px"
                  value={line}
                  onChange={event => {
                    setUnsavedChanges(true);
                    setLine(event.target.value);
                  }}
                />
              </Td>
              <Td>
                <Input
                  maxWidth="150px"
                  value={color}
                  onChange={event => {
                    setUnsavedChanges(true);
                    setColor(event.target.value);
                  }}
                />
              </Td>
              <Td>
                <NumberInput
                  maxWidth="100px"
                  value={unit}
                  onChange={value => {
                    setUnsavedChanges(true);
                    setUnit(value);
                  }}
                >
                  <NumberInputField />
                </NumberInput>
              </Td>
              <Td>
                <NumberInput
                  maxWidth="100px"
                  value={pricePer}
                  onChange={value => {
                    setUnsavedChanges(true);
                    setPricePer(value);
                  }}
                >
                  <NumberInputField />
                </NumberInput>
              </Td>
              <Td>
                <NumberInput
                  maxWidth="90px"
                  value={extraLaborPerSq}
                  onChange={value => {
                    setUnsavedChanges(true);
                    setExtraLaborPerSq(value);
                  }}
                >
                  <NumberInputField />
                </NumberInput>
              </Td>
              <Td>
                <VStack align="flex-start">
                  <HStack>
                    <Checkbox
                      size="sm"
                      isChecked={hasPaymentOptionOne}
                      onChange={event => {
                        setUnsavedChanges(true);
                        setHasPaymentOptionOne(event.target.checked);
                      }}
                    ></Checkbox>
                    <Text fontSize="xs">{oneYearDescription}</Text>
                  </HStack>
                  <HStack>
                    <Checkbox
                      size="sm"
                      isChecked={hasPaymentOptionThree}
                      onChange={event => {
                        setUnsavedChanges(true);
                        setHasPaymentOptionThree(event.target.checked);
                      }}
                    ></Checkbox>
                    <Text fontSize="xs">{threeYearDescription}</Text>
                  </HStack>
                  <HStack>
                    <Checkbox
                      size="sm"
                      isChecked={hasPaymentOptionSeven}
                      onChange={event => {
                        setUnsavedChanges(true);
                        setHasPaymentOptionSeven(event.target.checked);
                      }}
                    ></Checkbox>
                    <Text fontSize="xs">{sevenYearDescription}</Text>
                  </HStack>
                </VStack>
              </Td>
              <Td>
                <Box flex={1}>
                  <Textarea
                    value={estimateDescription}
                    onChange={e => {
                      setUnsavedChanges(true);
                      setEstimateDescription(e.target.value);
                    }}
                    placeholder="Enter a description..."
                    rows={6}
                  />
                </Box>
              </Td>
            </Tr>
            <Tr>
              <Td>Better</Td>
              <Td>
                <Input
                  maxWidth="150px"
                  value={manufacturerBetter}
                  onChange={event => {
                    setUnsavedChanges(true);
                    setManufacturerBetter(event.target.value);
                  }}
                />
              </Td>
              <Td>
                <Input
                  maxWidth="150px"
                  value={shingleTypeBetter}
                  onChange={event => {
                    setUnsavedChanges(true);
                    setShingleTypeBetter(event.target.value);
                  }}
                />
              </Td>
              <Td>
                <Input
                  maxWidth="200px"
                  value={lineBetter}
                  onChange={event => {
                    setUnsavedChanges(true);
                    setLineBetter(event.target.value);
                  }}
                />
              </Td>
              <Td>
                <Input
                  maxWidth="150px"
                  value={colorBetter}
                  onChange={event => {
                    setUnsavedChanges(true);
                    setColorBetter(event.target.value);
                  }}
                />
              </Td>
              <Td>
                <NumberInput
                  maxWidth="100px"
                  value={unitBetter}
                  onChange={value => {
                    setUnsavedChanges(true);
                    setUnitBetter(value);
                  }}
                >
                  <NumberInputField />
                </NumberInput>
              </Td>
              <Td>
                <NumberInput
                  maxWidth="100px"
                  value={pricePerBetter}
                  onChange={value => {
                    setUnsavedChanges(true);
                    setPricePerBetter(value);
                  }}
                >
                  <NumberInputField />
                </NumberInput>
              </Td>
              <Td>
                <NumberInput
                  maxWidth="100px"
                  value={extraLaborPerSqBetter}
                  onChange={value => {
                    setUnsavedChanges(true);
                    setExtraLaborPerSqBetter(value);
                  }}
                >
                  <NumberInputField />
                </NumberInput>
              </Td>
              <Td>
                <VStack align="flex-start">
                  <HStack>
                    <Checkbox
                      size="sm"
                      isChecked={hasPaymentOptionOneBetter}
                      onChange={event => {
                        setUnsavedChanges(true);
                        setHasPaymentOptionOneBetter(event.target.checked);
                      }}
                    ></Checkbox>
                    <Text fontSize="xs">{oneYearDescription}</Text>
                  </HStack>
                  <HStack>
                    <Checkbox
                      size="sm"
                      isChecked={hasPaymentOptionThreeBetter}
                      onChange={event => {
                        setUnsavedChanges(true);
                        setHasPaymentOptionThreeBetter(event.target.checked);
                      }}
                    ></Checkbox>
                    <Text fontSize="xs">{threeYearDescription}</Text>
                  </HStack>
                  <HStack>
                    <Checkbox
                      size="sm"
                      isChecked={hasPaymentOptionSevenBetter}
                      onChange={event => {
                        setUnsavedChanges(true);
                        setHasPaymentOptionSevenBetter(event.target.checked);
                      }}
                    ></Checkbox>
                    <Text fontSize="xs">{sevenYearDescription}</Text>
                  </HStack>
                </VStack>
              </Td>
              <Td>
                <Box flex={1}>
                  <Textarea
                    value={estimateDescriptionBetter}
                    onChange={e => {
                      setUnsavedChanges(true);
                      setEstimateDescriptionBetter(e.target.value);
                    }}
                    placeholder="Enter a description..."
                    rows={6}
                  />
                </Box>
              </Td>
            </Tr>
            <Tr>
              <Td>Best</Td>
              <Td>
                <Input
                  maxWidth="150px"
                  value={manufacturerBest}
                  onChange={event => {
                    setUnsavedChanges(true);
                    setManufacturerBest(event.target.value);
                  }}
                />
              </Td>
              <Td>
                <Input
                  maxWidth="150px"
                  value={shingleTypeBest}
                  onChange={event => {
                    setUnsavedChanges(true);
                    setShingleTypeBest(event.target.value);
                  }}
                />
              </Td>
              <Td>
                <Input
                  maxWidth="200px"
                  value={lineBest}
                  onChange={event => {
                    setUnsavedChanges(true);
                    setLineBest(event.target.value);
                  }}
                />
              </Td>
              <Td>
                <Input
                  maxWidth="150px"
                  value={colorBest}
                  onChange={event => {
                    setUnsavedChanges(true);
                    setColorBest(event.target.value);
                  }}
                />
              </Td>
              <Td>
                <NumberInput
                  maxWidth="100px"
                  value={unitBest}
                  onChange={value => {
                    setUnsavedChanges(true);
                    setUnitBest(value);
                  }}
                >
                  <NumberInputField />
                </NumberInput>
              </Td>
              <Td>
                <NumberInput
                  maxWidth="100px"
                  value={pricePerBest}
                  onChange={value => {
                    setUnsavedChanges(true);
                    setPricePerBest(value);
                  }}
                >
                  <NumberInputField />
                </NumberInput>
              </Td>
              <Td>
                <NumberInput
                  maxWidth="100px"
                  value={extraLaborPerSqBest}
                  onChange={value => {
                    setUnsavedChanges(true);
                    setExtraLaborPerSqBest(value);
                  }}
                >
                  <NumberInputField />
                </NumberInput>
              </Td>
              <Td>
                <VStack align="flex-start">
                  <HStack>
                    <Checkbox
                      size="sm"
                      isChecked={hasPaymentOptionOneBest}
                      onChange={event => {
                        setUnsavedChanges(true);
                        setHasPaymentOptionOneBest(event.target.checked);
                      }}
                    ></Checkbox>
                    <Text fontSize="xs">{oneYearDescription}</Text>
                  </HStack>
                  <HStack>
                    <Checkbox
                      size="sm"
                      isChecked={hasPaymentOptionThreeBest}
                      onChange={event => {
                        setUnsavedChanges(true);
                        setHasPaymentOptionThreeBest(event.target.checked);
                      }}
                    ></Checkbox>
                    <Text fontSize="xs">{threeYearDescription}</Text>
                  </HStack>
                  <HStack>
                    <Checkbox
                      size="sm"
                      isChecked={hasPaymentOptionSevenBest}
                      onChange={event => {
                        setUnsavedChanges(true);
                        setHasPaymentOptionSevenBest(event.target.checked);
                      }}
                    ></Checkbox>
                    <Text fontSize="xs">{sevenYearDescription}</Text>
                  </HStack>
                </VStack>
              </Td>
              <Td>
                <Box flex={1}>
                  <Textarea
                    value={estimateDescriptionBest}
                    onChange={e => {
                      setUnsavedChanges(true);
                      setEstimateDescriptionBest(e.target.value);
                    }}
                    placeholder="Enter a description..."
                    rows={6}
                  />
                </Box>
              </Td>
            </Tr>
          </Tbody>
        </Table>
        <div>
          <Table size="sm">
            <Thead>
              <Tr>
                <Th></Th>
                <Th fontSize="xs">Warranty Name</Th>
                <Th fontSize="xs">Warranty Price</Th>
                <Th fontSize="xs">Warranty</Th>
              </Tr>
            </Thead>
            <Tbody>
              <Tr>
                <Td>Option 1</Td>
                <Td>
                  <Input
                    maxWidth="200px"
                    size="sm"
                    value={warrantyName}
                    onChange={event => {
                      setUnsavedChanges(true);
                      setWarrantyName(event.target.value);
                    }}
                  />
                </Td>
                <Td>
                  <NumberInput
                    maxWidth="150px"
                    value={warrantyPrice}
                    onChange={value => {
                      setUnsavedChanges(true);
                      setWarrantyPrice(value);
                    }}
                  >
                    <NumberInputField />
                  </NumberInput>
                </Td>
                <Td>
                  <RadioGroup
                    value={isPerJob ? 'isPerJob' : isPerSq ? 'isPerSq' : null}
                    onChange={value => {
                      if (value === 'isPerJob') {
                        setIsPerJob(true);
                        setIsPerSq(false);
                      } else if (value === 'isPerSq') {
                        setIsPerSq(true);
                        setIsPerJob(false);
                      }
                    }}
                  >
                    <Stack>
                      <Radio value="isPerJob">
                        <Text whiteSpace="nowrap">Per Job</Text>
                      </Radio>
                      <Radio value="isPerSq">
                        <Text whiteSpace="nowrap">Per Sq</Text>
                      </Radio>
                    </Stack>
                  </RadioGroup>
                </Td>
              </Tr>
              <Tr>
                <Td>Option 2</Td>
                <Td>
                  <Input
                    maxWidth="200px"
                    size="sm"
                    value={warrantyNameTwo}
                    onChange={event => {
                      setUnsavedChanges(true);
                      setWarrantyNameTwo(event.target.value);
                    }}
                  />
                </Td>
                <Td>
                  <NumberInput
                    maxWidth="150px"
                    value={warrantyPriceTwo}
                    onChange={value => {
                      setUnsavedChanges(true);
                      setWarrantyPriceTwo(value);
                    }}
                  >
                    <NumberInputField />
                  </NumberInput>
                </Td>
                <Td>
                  <RadioGroup
                    value={
                      isPerJobTwo ? 'isPerJob' : isPerSqTwo ? 'isPerSq' : null
                    }
                    onChange={value => {
                      if (value === 'isPerJob') {
                        setIsPerJobTwo(true);
                        setIsPerSqTwo(false);
                      } else if (value === 'isPerSq') {
                        setIsPerSqTwo(true);
                        setIsPerJobTwo(false);
                      }
                    }}
                  >
                    <Stack>
                      <Radio value="isPerJob">
                        <Text whiteSpace="nowrap">Per Job</Text>
                      </Radio>
                      <Radio value="isPerSq">
                        <Text whiteSpace="nowrap">Per Sq</Text>
                      </Radio>
                    </Stack>
                  </RadioGroup>
                </Td>
              </Tr>
            </Tbody>
          </Table>
        </div>
      </VStack>
      <Center>
        <VStack>
          {unsavedChanges && (
            <Alert status="warning" marginTop="5">
              <AlertIcon />
              <AlertTitle>You have unsaved changes!</AlertTitle>
            </Alert>
          )}
          {!savedList.includes('shingles') && (
            <Alert status="info" marginTop="5">
              <AlertIcon />
              <AlertTitle>Review and Save</AlertTitle>
            </Alert>
          )}
          <Button colorScheme="blue" marginTop="3" onClick={handleSave}>
            Save
          </Button>
        </VStack>
      </Center>
    </Box>
  );
};

export default ShinglesPrices;
